module.exports = __webpack_public_path__ + "static/media/eduardanghel.9ed9663e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/eduardanghel.webp
// module id = 352
// module chunks = 0